// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shelf_Px0iV {
  display: flex;
  height: 100%;
  width: 100%;
  gap: var(--size-padLarge);
  overflow-x: scroll;
}

.content_vcjVF {
  height: 100%;
  width: 100%;
}

.occupied_LCLRT {
  cursor: pointer;
}

.area_bPheo {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 415px 500px;
  row-gap: 30px;
  column-gap: 30px;
  padding: 0 30px;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/shelfMonitoring/ShelfCards.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".shelf {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  gap: var(--size-padLarge);\n  overflow-x: scroll;\n}\n\n.content {\n  height: 100%;\n  width: 100%;\n}\n\n.occupied {\n  cursor: pointer;\n}\n\n.area {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 415px 500px;\n  row-gap: 30px;\n  column-gap: 30px;\n  padding: 0 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shelf": `shelf_Px0iV`,
	"content": `content_vcjVF`,
	"occupied": `occupied_LCLRT`,
	"area": `area_bPheo`
};
export default ___CSS_LOADER_EXPORT___;
